import { render, staticRenderFns } from "./PwaPrompt.vue?vue&type=template&id=0376defe&scoped=true&"
import script from "./PwaPrompt.vue?vue&type=script&lang=js&"
export * from "./PwaPrompt.vue?vue&type=script&lang=js&"
import style0 from "./PwaPrompt.vue?vue&type=style&index=0&id=0376defe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0376defe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0376defe')) {
      api.createRecord('0376defe', component.options)
    } else {
      api.reload('0376defe', component.options)
    }
    module.hot.accept("./PwaPrompt.vue?vue&type=template&id=0376defe&scoped=true&", function () {
      api.rerender('0376defe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/PwaPrompt.vue"
export default component.exports